<template>
    <div class="FuncVipTip-cover">
        <Dialog
            ref="FuncVipTipModal"
            id="FuncVipTip-modal"
            :mask="mask"
            :title="$t('title')"
            :isShow="true"
            :extra="isExtra"
            @close="close"
            :class="{ 'small-modal': upgradeTrigger === 'removeGrid', 'big-width-modal': lang !== 'zh' }"
        >
            <div class="modal-main">
                <div class="left">
                    <div class="tip-content">
                        <div class="content-main">
                            <div class="text">
                                <span>{{ $t("used") }}</span>
                                <span class="num">{{ usedVipNum }}</span>
                                <span>{{ $t("vipBenefits") }}</span>
                            </div>
                            <Tooltip class="help-icon-tooltip" placement="top" :content="tipsContent">
                                <iconSymbol class="help-icon img-24" name="help-menu" />
                            </Tooltip>
                        </div>
                        <div class="content-desc fs-14 color-222">{{ $t(tipDesc) }}</div>
                    </div>
                    <div class="benefits">
                        <div class="benefits-title fs-14 color-222">{{ $t("benefitsTitle") }}</div>
                        <div class="benefits-list">
                            <template v-for="item in 8">
                                <div class="benefit-item" v-if="lang === 'zh' || (item !== 8 && lang !== 'zh')" :key="item">
                                    <img class="img-24" :src="require(`@/app/assets/img/vip-tip/benefit${item}.svg`)" alt="" />
                                    <span class="fs-14" :class="{ 'click-text': item == 8 }" @click="showVipBenefitModal(item)">
                                        {{ $t(`benefitText${item}`) }}
                                    </span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="vip-btn fs-14" @click="toBuy">
                        <div class="top-tip" v-if="!!purchaseBubble">{{ purchaseBubble }}</div>
                        <span>{{ $t(vipBtnText) }}</span>
                    </div>
                </div>
                <div class="right">
                    <div class="badge-title fs-14">
                        {{ $t("badgeTitle") }}
                    </div>
                    <div class="badges">
                        <div class="badge-item" v-for="item in 3" :key="item">
                            <img :src="require(`@/app/assets/img/vip-tip/badge${item}.png`)" alt="" />
                        </div>
                    </div>
                    <div class="platform">
                        <div class="platform-title fs-14">{{ $t("platformTitle") }}</div>
                        <div class="platform-list">
                            <div class="platform-item" v-for="item in 6" :key="item">
                                <img :src="require(`@/app/assets/img/vip-tip/platform${item}.svg`)" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class FuncVipTip extends Vue {
        @Prop({ default: false }) mask;
        @Prop({ default: () => [] }) vipFuncs: Array<string>;
        @Prop({ default: null }) closeCallback: Function;
        @Prop({ default: "" }) upgradeTrigger;

        get isExtra() {
            return this.$store.state.dialog.showDialog;
        }

        get usedVipNum() {
            return this.vipFuncs.length || 0;
        }
        get tipsContent() {
            return this.vipFuncs
                .map((func) => {
                    return this.$t(func);
                })
                .join("、");
        }

        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble;
        }

        get tipDesc() {
            if (this.upgradeTrigger.indexOf("export") > -1) {
                return "exportTipDesc";
            }
            if (this.upgradeTrigger.indexOf("FileWithVipBenefit") > -1) {
                return `${this.upgradeTrigger.replace("FileWithVipBenefit", "")}TipDesc`;
            }
            return "";
        }

        get vipBtnText() {
            if (this.upgradeTrigger.indexOf("export") > -1) {
                return "exportVipBtn";
            }
            if (this.upgradeTrigger.indexOf("FileWithVipBenefit") > -1) {
                return `${this.upgradeTrigger.replace("FileWithVipBenefit", "")}VipBtn`;
            }
            return "vipBtn";
        }

        close() {
            if (this.vipFuncs.indexOf("funcGrid") > -1 && !this.vip) {
                let view = window["_view"];
                if (!view) return;
                view.showGridBox(true);
                this.$store.commit("setStatus", {
                    type: "removeGrid",
                    data: true,
                });
            }
            if (this.$store.state.ui.saveMathSymbol) {
                this.$store.commit("setStatus", {
                    type: "saveMathSymbol",
                    data: false,
                });
            }
            this.closeCallback && this.closeCallback();
            this.$bus.$emit("toggleFuncVipTip", { visible: false });
            this.sensors.track("clickButtonInVipRemindWindow", {
                Catalogues: "payPath",
                button_name: "close",
            });
        }

        showVipBenefitModal(item) {
            if ((this.internal || (!this.internal && this.lang === "zh")) && item === 8) {
                this.sensors.track("clickButtonInVipRemindWindow", {
                    Catalogues: "payPath",
                    button_name: "learnMore",
                });
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: this.upgradeTrigger,
                });
                if (!this.internal && this.lang === "zh") {
                    this.$openBuyPage(this.upgradeTrigger);
                    return;
                }
                this.$store.commit("toPublicStatus", {
                    type: "upgradeSuffix",
                    data: "action=compare",
                });
                this.$store.commit("toPublicStatus", {
                    type: "showBuyframe",
                    data: true,
                });
            }
            return;
        }
        toBuy() {
            this.$bus.$emit("toggleFuncVipTip", { visible: false });
            this.$openBuyPage(this.upgradeTrigger);
            let view = window["_view"];
            if (!view) return;
            view.showGridBox(true);
            this.$store.commit("setStatus", {
                type: "removeGrid",
                data: true,
            });
            if (this.$store.state.ui.saveMathSymbol) {
                this.$store.commit("setStatus", {
                    type: "saveMathSymbol",
                    data: false,
                });
            }
            this.sensors.track("clickButtonInVipRemindWindow", {
                Catalogues: "payPath",
                button_name: "buyNow",
            });
        }
        mounted() {}
    }
</script>

<style scoped lang="stylus">
    .fs-14
      font-size 14px
    .color-222
      color #222
    .img-24
      display inline-block
      width 24px
      height 24px

    .FuncVipTip-cover
      position fixed
      top 0
      right 0
      bottom 0
      left 0
      z-index 101;
      .dialog-container-component
        overflow hidden
        border 0px

    /deep/.ivu-tooltip-popper .ivu-tooltip-arrow
      border-top-color: #161B22 !important

    #FuncVipTip-modal
      width 740px
      height 492px
      overflow visible
      /deep/.dialog-title
        position absolute
        background transparent
      /deep/.dialog-slot
        padding 0 0
        height 100%
      .modal-main
        display flex
        height 100%
        .left
          padding-top 40px
          padding 56px 24px 24px
          width 368px
          .tip-content
            .content-main
              font-size 16px
              font-weight 700
              display flex
              align-items center
              margin-bottom 8px
              .help-icon-tooltip
                  height 24px
                  /deep/.ivu-tooltip-rel
                    width 32px
                  /deep/.ivu-tooltip-inner
                    background-color #161B22
                    border-radius 8px
                    font-weight 400
                    max-width 344px
                    white-space wrap


              .text
                line-height 24px
                .num
                  margin 0 5px


              .help-icon
                margin-left 4px
                cursor pointer
            .content-desc
              line-height 24px
          .benefits
            margin-top 32px
            .benefits-title
              margin-bottom 24px
            .benefits-list
              display flex
              flex-wrap wrap
              justify-content space-between
              align-items center
              row-gap 24px
              .benefit-item
                display flex
                align-items center
                width 150px
                img
                  margin-right 8px
              .click-text
                color var(--themeColor)
                cursor pointer
                &:hover
                 opacity 0.8
          .vip-btn
            margin 63px 0px 24px
            width 100%
            height 40px
            text-align center
            // padding 12px
            border-radius 6px
            background linear-gradient(to right, #FFEF92 10%, #FFD67B 90%)
            color #402300
            cursor pointer
            position relative
            &:hover
              background #FFD67B
            .top-tip
              position absolute
              bottom 26px
              right 0
              background linear-gradient(to left, #FF4848, #FF9C55)
              border-radius  10px 10px 0px 10px
              padding 5px
              line-height 10px
              color #fff
              font-size 10px
            span
              line-height 40px

        .right
          flex 1
          padding 40px 24px 56px
          border-radius 0 8px 8px 0
          // background linear-gradient(to bottom, #9ED1FF, #FFFFFF)
          background url('~@/app/assets/img/vip-tip/right-bg.png')
          .badge-title
            text-align center
            padding-top 16px
            line-height 24px
          .badges
            display flex
            justify-content space-between
            padding-bottom 36px
            border-bottom 1px dashed rgba(0,0,0,0.08)
            margin-top 36px
            .badge-item
              img
                display block
                width 96px
                height 140px
          .platform
            margin-top 33px
            .platform-title
              color rgba(0,0,0,0.5)
              text-align center
              margin-bottom 24px
            .platform-list
              display flex
              justify-content space-between
              align-items center
              .platform-item
                // background rgba(255,255,255,0.5)
                border-radius 8px
                padding 12px
                position relative
                width 42px
                height 42px
                &::before
                  position absolute
                  left 0
                  top 0
                  z-index 2
                  content ""
                  display block
                  width 42px
                  height 42px
                  background  #f2faff
                  border-radius 8px
                &::after
                  position absolute
                  left -1px
                  top -1px
                  z-index 1
                  content ""
                  display block
                  width 44px
                  height 44px
                  background linear-gradient(45deg,rgba(255,255,255,0.5),#fff)
                  border-radius 8px
                img
                  display block
                  width 20px
                  height 20px
                  position relative
                  z-index 3
    #FuncVipTip-modal.small-modal
        height 460px
        .modal-main
          .right
            .badges
              margin-top 32px
              padding-bottom 28px
            .platform
              margin-top 21px
    #FuncVipTip-modal.big-width-modal
      width 820px
      height max-content
      .left
        width 448px
        .benefits
          .benefits-list
            .benefit-item
              width 195px
        .vip-btn
          margin 73px 0 0
      .right
        background-size cover
</style>

<i18n>
{
  "zh": {
    "title": "会员提示",
    "used":"您已使用",
    "vipBenefits": "个会员特权",
    "exportTipDesc": "需要开通会员才能导出此文件噢",
    "publishTipDesc": "需要开通会员才能发布此作品到社区噢",
    "shareTipDesc": "需要开通会员才能分享此作品噢",
    "printTipDesc": "需要开通会员才能打印此文件噢",
    "downloadTipDesc": "需要开通会员才能保存此文件到本地噢",
    "benefitsTitle": "亿图图示会员尊享30+特权",
    "funcGrid": "移除网格线",
    "funcAutoShowConnectorAnimation": "默认开启流向动画",
    "lineAnimationLimitCount": "流向动画",
    "funcSymbol": "符号",
    "funcTemplate": "模板",
    "funcShapeNum": "形状数",
    "funcPageTheme": "主题",
    "funcPageColor": "颜色",
    "funcPageConnect": "连接线",
    "funcAutoBeautify": "一键美化",
    "funcPageBackground": "背景颜色",
    "funcDocWatermark": "水印",
    "funcDocNum": "页面",
    "funcShapeMath": "公式",
    "funcShapePPT": "文字",
    "benefitText1": "绘图符号无限用",
    "benefitText2": "精品模板无限用",
    "benefitText3": "文件无水印导出",
    "benefitText4": "10G超大云空间",
    "benefitText5": "AI绘图智能体验",
    "benefitText6": "画布背景设置",
    "benefitText7": "百万制图素材",
    "benefitText8": "查看所有特权",
    "vipBtn": "开通VIP",
    "exportVipBtn": "开通VIP后导出",
    "downloadVipBtn": "开通VIP后保存",
    "publishVipBtn": "开通VIP后发布",
    "shareVipBtn": "开通VIP后分享",
    "printVipBtn": "开通VIP后打印",
    "badgeTitle": "亿图图示（EdrawMax）已为全球2000万用户提供通用办公绘图服务，累计获得10万企业信任",
    "platformTitle": "会员权益多平台通用"
  },
  "en": {
    "title": "Reminder for Premium benefits",
    "used":"You have used",
    "vipBenefits": "premium benefit(s)",
    "benefitsTitle": "EdrawMax Pro enjoy 30+ benefits.",
    "funcGrid": "Remove grid",
    "funcAutoShowConnectorAnimation": "",
    "lineAnimationLimitCount": "Flow Animation",
    "funcSymbol": "Symbol",
    "funcTemplate": "Template",
    "funcShapeNum": "Number of shapes",
    "funcPageTheme": "Theme",
    "funcPageColor": "Color",
    "funcPageConnect": "Connector",
    "funcAutoBeautify": "One Click Beautifty",
    "funcPageBackground": "Background Color",
    "funcDocWatermark": "Watermark",
    "funcDocNum": "Pages",
    "funcShapeMath": "Formula",
    "funcShapePPT": "Text",
    "benefitText1": "Unlimited use of drawing symbols",
    "benefitText2": "Unlimited use of boutique templates",
    "benefitText3": "Export files with no watermarks",
    "benefitText4": "10GB cloud storage",
    "benefitText5": "Intelligent AI Drawings",
    "benefitText6": "Canvas background settings",
    "benefitText7": "Millions of visual assets",
    "benefitText8": "View All Benefits",
    "badgeTitle": "EdrawMax has provided diagram services to 20 million users worldwide and gained the trust of 100,000 enterprises.",
    "platformTitle": "Premium is available in multiple platforms",
    "exportTipDesc": "To export this file, you need to become a premium first.",
    "publishTipDesc": "To publish your work to the community, you need to become a premium first.",
    "shareTipDesc": "To share your work, you need to become a premium first.",
    "printTipDesc": "To print this file, you need to become a premium first.",
    "downloadTipDesc": "To save the file locally, you need to become a premium first.",
    "vipBtn": "Buy now",
    "exportVipBtn": "Buy now to export",
    "downloadVipBtn": "Buy now to save",
    "publishVipBtn": "Buy now to publish",
    "shareVipBtn": "Buy now to share",
    "printVipBtn": "Buy now to print"
  }
}
</i18n>
